import { useQuery } from "@tanstack/react-query";
import useApi from "../utils/useApi";

export default function useFlowDetectionsProcessData(
  start_datetime,
  end_datetime,
  zones,
  collections,
  enabled
) {
  const { getProcessedData } = useApi();

  const { data, isLoading } = useQuery({
    queryKey: [
      "flowDetectionsProcessData",
      start_datetime,
      end_datetime,
      zones,
      collections,
    ],
    queryFn: () =>
      getProcessedData({
        start_datetime,
        end_datetime,
        zones,
        collections,
      }),
    enabled,
  });
  return { data: data?.data, isLoading };
}
